import enviro from 'enviro';
export default function envSuffix() {
  return enviro.getShort() === 'qa' ? 'qa' : '';
}